import VanillaMask from "vanilla-masker";

export default budget => {
  return {
    id: budget.id,
    protocol: budget.protocol.value,
    descriptionScope: budget.descriptionScope,
    hirer: {
      label: budget.hirer.fantasyName,
      value: budget.hirer.id
    },
    provider: {
      label: budget.provider.fantasyName,
      value: budget.provider.id
    },
    owner: budget.owner,
    commissionPercentage: budget.servicePercentage
      ? budget.servicePercentage
      : 0.15,
    material: {
      percentage: budget.materialPercentage ? budget.materialPercentage : 0
    },
    refund: {
      percentage: budget.refundPercentage ? budget.refundPercentage : 0
    },
    bulkMaterial: budget.material.map(material => ({
      measuredUnit: material.measuredUnit,
      name: material.name,
      quantity: material.quantity,
      total: material.total,
      unitPrice: material.unitPrice * 100
    })),
    bulkService: budget.service,
    bulkExpense: budget.refund.map(expense => ({
      measuredUnit: expense.measuredUnit,
      name: expense.name,
      quantity: expense.quantity,
      total: expense.total,
      unitPrice: expense.unitPrice * 100
    })),
    executionDeadline: budget.executionDeadline,
    details: budget.details,
    paymentMethod: budget.paymentMethod,
    serviceValueDiscount:
      budget.serviceValueDiscount && budget.serviceValueDiscount * 100,
    serviceValueTotal:
      budget.serviceValueTotal && budget.serviceValueTotal * 100,
    materialValueDiscount: VanillaMask.toMoney(
      budget.materialValueDiscount
        ? budget.materialValueDiscount
        : budget.materialValueDiscount === 0,
      {
        precision: 2,
        separator: ",",
        delimiter: ".",
        unit: "R$",
        zeroCents: true
      }
    ),
    materialValueTotal: VanillaMask.toMoney(
      budget.materialValueTotal
        ? budget.materialValueTotal
        : budget.materialValueTotal === 0,
      {
        precision: 2,
        separator: ",",
        delimiter: ".",
        unit: "R$",
        zeroCents: true
      }
    ),
    refundValueTotal: VanillaMask.toMoney(
      budget.refundValueTotal
        ? budget.refundValueTotal
        : budget.refundValueTotal === 0,
      {
        precision: 2,
        separator: ",",
        delimiter: ".",
        unit: "R$",
        zeroCents: true
      }
    )
  };
};



// WEBPACK FOOTER //
// ./src/pages/budget/BudgetBuildFormObject.js